import { Injectable, ElementRef } from '@angular/core';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  XLSX = undefined;
  fileSaver = undefined;
  constructor() {}

  async getXLSXInstance() {
    if (this.XLSX === undefined) {
      this.XLSX = await import('xlsx');
    }
    return this.XLSX;
  }

  async getFileSaverInstance() {
    if (this.fileSaver === undefined) {
      this.fileSaver = await import('file-saver');
    }
    return this.fileSaver;
  }

  public async exportAsExcelFile(json: any[], excelFileName: string, legList: any[]): Promise<void> {
    let XLSX = (await this.getXLSXInstance()) as any;
    const worksheet = XLSX.utils.json_to_sheet(json);
    const list = XLSX.utils.json_to_sheet(legList);
    const workbook = { Sheets: { Sheet1: worksheet, Sheet2: list }, SheetNames: ['Sheet1', 'Sheet2'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    await this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  public async exportAsExcelSingleFile(json: any[], excelFileName: string): Promise<void> {
    let XLSX = (await this.getXLSXInstance()) as any;
    const worksheet = XLSX.utils.json_to_sheet(json);
    const keys = Object.keys(json[0] || {});
    worksheet['!cols'] = keys.map((k) => ({
      wch: Math.max(k.length, ...json.map((r) => (r[k] ? r[k].toString().length : 0))) + 2,
    }));
    const workbook = { Sheets: { Sheet1: worksheet }, SheetNames: ['Sheet1'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    await this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private async saveAsExcelFile(buffer: any, fileName: string): Promise<void> {
    let fileSaver = (await this.getFileSaverInstance()) as any;
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    fileSaver?.default?.saveAs(data, fileName);
  }
}
